<template>

    <!--


    -->
    <div>

        <v-navigation-drawer v-model="drawer" app temporary dark   class="color_main">

            <v-list>
                <v-list-item>
                    <!--
                    <v-list-item-avatar>
                        <img src="@/assets/logo_empresa.jpg" alt="kwsoluciones">                      
                    </v-list-item-avatar>
                     <img src="@/assets/img/logo.png"  width="180px" alt="Spacio"> 
                -->
                <img src="@/assets/img/logo_kw.png"  width="180px" alt="kW soluciones"> 
               
                    <v-list-item-content>
                        <span ><h4>{{title}}</h4></span>
                    </v-list-item-content>
                </v-list-item>
            </v-list>

            <v-divider />


            <v-list dense>

                <span v-for="(item, index) in itemsMenu" :key="index">
                    
                    <!-- menu simple -->
                    <v-list-item v-if="item.link_modulo!=''" @click="$vuetify.goTo(item.link_modulo)" >
                        <v-list-item-content>
                            <v-list-item-title >{{item.nombre_modulo}}</v-list-item-title>
                        </v-list-item-content>

                        <!-- <v-list-item-icon>
                            <v-icon>mdi-home</v-icon>
                        </v-list-item-icon> -->
                    </v-list-item>


                    <!-- menu con sub menu -->
                    <v-list-group v-else no-action>
                        <template v-slot:activator>
                            <v-list-item-content>
                                <v-list-item-title>{{item.nombre_modulo}}</v-list-item-title>
                            </v-list-item-content>
                        </template>
                        
                                     
                        <v-list-item v-for="(subModulo, index) in item.subModulo" :key="index" link>
                            <v-list-item-title @click="$vuetify.goTo(subModulo.link_submodulo)">{{ subModulo.nombre_submodulo }}</v-list-item-title>
                        </v-list-item>
                    </v-list-group>
                </span>
                <!--
                <v-btn to="/login" class="ml-4 btn_secondary">
                    Ingresar
                </v-btn>  -->

            </v-list>
        </v-navigation-drawer>




        <!--
            EXPANDER  ORIGINAL
            <v-app-bar app :color="color" :flat="flat" dark class="px-5" :class="{expand: flat, 'pt-10': flat, 'black--text': flat}"> -->
            <v-app-bar app :flat="flat"  dark class="px-5 color_main" >

            <v-toolbar-title>
                <!--
                <v-avatar size="60">
                    <img src="@/assets/logo_empresa.jpg"  alt="kwsoluciones"> 
                    <img src="@/assets/img/logo.svg" alt="Colegio Enfermeria">
                       <img src="@/assets/img/logo_kw.jpg"  width="180px" alt="Spacio"> 
                </v-avatar> -->

                <img src="@/assets/img/logo_kw.png"  width="120px"  height="60px"   alt="KW soluciones"> 
                <!-- <img src="https://cdn.vuetifyjs.com/images/john.jpg" alt="John">
                    <v-img src="@/assets/img/logo.png" max-width="50px" /> -->
            </v-toolbar-title>

            <h3 class="pl-2">{{ title }}</h3>

            <v-spacer />


            <v-app-bar-nav-icon v-if="isXs" @click.stop="drawer = !drawer" class="mr-4"/>

            <div v-else>
                
                <span v-for="(item, index) in itemsMenu" :key="index">
                     <!-- Modulo o menu simple -->
                    <!--    // HACER  LINK DIRECTAMENTE  USAR TO   :to="item.link_modulo"  vs  $vuetify.goTo
                    <v-btn v-if="item.link_modulo!=''" text  :to="item.link_modulo" :class="{'black--text': flat}">
                            {{item.nombre_modulo}} 
                        </v-btn>  
                    -->
                     <v-btn v-if="item.link_modulo!=''" text @click="$vuetify.goTo(item.link_modulo)"  :class="{'white--text': flat}">
                            {{item.nombre_modulo}} 
                        </v-btn>
                    <!-- menu con sub Modulos o sub Menu -->
                    <v-menu v-else offset-y open-on-hover transition="slide-y-transition">

                        <template v-slot:activator="{ on, attrs }" >

                            <v-btn text v-bind="attrs" v-on="on" :class="{'white--text': flat}">
                                {{item.nombre_modulo}}
                                <v-icon right small>
                                    fas fa-chevron-down
                                </v-icon>
                            </v-btn>
                        </template>

                    <!-- listar sub Modulos -->
                        <v-list nav>
                            
                            <v-list-item-group color="secondary">
                                <v-list-item v-for="(subModulo, index02) in item.subModulo" :key="index02">
                                    
                                    <v-list-item-title v-if="subModulo.evento"  @click="eventMenu(subModulo)">{{ subModulo.nombre_submodulo }}</v-list-item-title>
                                    
                                    <v-list-item-title v-else  @click="$vuetify.goTo(subModulo.link_submodulo)">{{ subModulo.nombre_submodulo }}</v-list-item-title>
                                    


                                </v-list-item>
                            </v-list-item-group>
                        </v-list>

                    </v-menu>

                 
                </span>
               

                <!-- Boton anexo para ingresar al sistema -->
                <!--
                <v-btn to="/login" class="ml-4 btn_secondary">
                    Ingresar
                </v-btn>

                -->

            </div>
        </v-app-bar>

    </div>
</template>



<script>
    import axios   from '@/helpers/axios'
    import {mapMutations} from 'vuex';

    export default {
        data: () => ({
            drawer: null,
            isXs: false,
            title:"",
            test:false,
            itemsMenu: [
                { nombre_modulo: 'Principal', link_modulo: '#principal',
                    
                    subModulo: [],
                },
                /*
                { nombre_modulo: 'Servicios', link_modulo:'#servicios',
                    subModulo: [],
                },
                */

                { nombre_modulo: 'Portafolio', link_modulo:'#portafolio',
                    subModulo: [],
                },
             
                { nombre_modulo: 'Contacto',link_modulo:'#contacto',
                    subModulo: [],
                },
            ],

            Datos: {},
            filter: {id_empresa:null, id_sucursal:null, estado_producto:true},
            search: ""


        }),


        props: {
            flat: Boolean,
        },

        mounted() {
            this.onResize();
            window.addEventListener("resize", this.onResize, { passive: true })
            this.loadMain()
        },

        watch: {
            isXs(value) {
                if (!value) {
                    if (this.drawer) {
                        this.drawer = false;
                    }
                }
            },
        },


        methods: {

            //  ------- MENSAJE DE SISTEMA  --------
            ...mapMutations('mensajeSis', ['setEnviarMens']),
            // ...mapMutations('eventMenu', ['loadingEventMenu', 'searchProduct', 'deleteEventMenu']),

            onResize() {
                this.isXs = window.innerWidth < 1200;
            },


            async loadMain(){
                // console.log("header.vue getQuery")               
            },

            
            async eventMenu(item){
                console.log(item)
                // this.loadingEventMenu(item)
                // this.setEnviarMens({tipo:resp.messageT, mensaje: `${resp.message}`, tiempo:null})     
            },


           

        },

       


    };
</script>



<style scoped>
    .v-toolbar {
        transition: 0.6s;
    }

    .expand {
        height: 80px !important;
        padding-top: 10px;
    }




</style>